"use client";
import { Box, BoxProps } from "@chakra-ui/react";

export interface CardProps extends Omit<BoxProps, "title"> {}
export const Card = (props: CardProps) => (
  <Box apply="styles.widgetStyles.card" {...props} />
);
